// extracted by mini-css-extract-plugin
export default {"title":"CourseChapters_title__EXeAb","main":"CourseChapters_main__9w6k2","toggleBtn":"CourseChapters_toggleBtn__JuuHe"};